import { createSlice } from "@reduxjs/toolkit";

export const withdrawalFormSlice = createSlice({
    name: 'withdrawal',
    initialState: {
        withdrawalAccount: {value: "blank", label: '-- select --'},
        withdrawalAmount: 0.00,
        currentBalance: 0,
        validAmountCheck: true,
        confirming: false,
        status: ''
    },
    reducers: {
        setWithdrawalAccount: (state, action) => {
            return {
                ...state,
                withdrawalAccount: action.payload,
                status: ''
            }
        },
        changeWithdrawalAmount: (state, action) => {
            return {
                ...state,
                withdrawalAmount: action.payload.withdrawalAmount,
                validAmountCheck: action.payload.validAmountCheck ? true : false
            }
        },
        changeWithdrawalAccountBalance: (state, action) => {
            return {
                ...state,
                currentBalance: action.payload
            }
        },
        clearWithdrawalForm: (state) => {
            return {
                ...state,
                withdrawalAccount: {value: 'blank', label: '-- select --'},
                withdrawalAmount: 0.00,
                currentBalance: "",
                validAmountCheck: true
            }
        },
        setConfirmingWithdrawal: (state, action) => {
            return {
                ...state,
                confirming: action.payload,
                status: ''
            }
        },
        changeWithdrawalFormStatus: (state, action) => {
            return {
                ...state,
                status: action.payload
            }
        }
    }
})

export const selectWithdrawalAccount = (state) => state.withdrawal.withdrawalAccount;
export const selectWithdrawalAmount = (state) => state.withdrawal.withdrawalAmount;
export const selectWithdrawalAccountBalance = (state) => state.withdrawal.currentBalance;
export const selectWithdrawalValidAmountCheck = (state) => state.withdrawal.validAmountCheck;
export const withdrawalIsConfirming = (state) => state.withdrawal.confirming;
export const selectWithdrawalFormStatus = (state) => state.withdrawal.status;

export const { 
    changeWithdrawalAccountBalance, 
    setWithdrawalAccount, 
    changeWithdrawalAmount, 
    clearWithdrawalForm, 
    setConfirmingWithdrawal, 
    changeWithdrawalFormStatus 
} = withdrawalFormSlice.actions;

export default withdrawalFormSlice.reducer;